import NotificationsNoneOutlined from "@mui/icons-material/NotificationsNoneOutlined";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import TermAccountNotificationsModal from "./TermAccountNotificationsModal";

const TermNotificationsCell = ({
  count = 0,
  clientAccountDetailId,
  termNumber,
  termLabel,
  clientId,
  onModalClose,
}) => {
  const [open, setOpen] = useState(false);

  if (!clientAccountDetailId || !termNumber) {
    return null;
  }

  return (
    <>
      <Tooltip title={count ? `${count} notification(s)` : "View notifications"}>
        <IconButton size="small" onClick={() => setOpen(true)}>
          <Badge
            badgeContent={count || 0}
            color="error"
            max={99}
            invisible={!count}
            sx={{ "& .MuiBadge-badge": { fontSize: 9, minWidth: 14, height: 14 } }}
          >
            <NotificationsNoneOutlined
              fontSize="small"
              className={count ? "text-primary" : "text-app-text-secondary"}
            />
          </Badge>
        </IconButton>
      </Tooltip>
      <TermAccountNotificationsModal
        open={open}
        onClose={() => {
          setOpen(false);
          onModalClose?.();
        }}
        clientAccountDetailId={clientAccountDetailId}
        termNumber={termNumber}
        termLabel={termLabel}
        clientId={clientId}
      />
    </>
  );
};

export default TermNotificationsCell;
